import { render, staticRenderFns } from "./ListaPrecioProductoListadoComponent.vue?vue&type=template&id=022a9b9d&"
import script from "./ListaPrecioProductoListadoComponent.vue?vue&type=script&lang=js&"
export * from "./ListaPrecioProductoListadoComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports